import { images } from "../Images/Svg";
const { AuditIcon, AuditIconFilled } = images;

export const vendorTabelData = [
  // 1
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "company_name",
        minWidth: "10rem",
        label: "Vendor Name",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "state",
        label: "Vendor State",
        align: "center",
      },

      {
        id: "city",
        label: "Vendor City",
        align: "left",
      },
      {
        id: "capacity_health",
        label: "Vendor Capacity",
        align: "center",
      },
      {
        id: "mobile_number",
        label: "Contact Details",
        align: "center",
      },
      {
        id: "createdAt",
        label: "Agreement Start Date",
        align: "center",
      },
      {
        id: "agreementExpiryDate",
        label: "Agreement Expiry Date",
        align: "center",
      },
      {
        id: "pan_number",
        label: "PAN No.",
        align: "center",
      },
      {
        id: "gst_number",
        label: "GSTIN No.",
        align: "center",
      },
      {
        id: "natureofService",
        label: "Nature of Service",
        align: "center",
      },
      {
        id: "Product",
        label: "Product",
        align: "center",
      },
    ],
    row: [
      {
        srNo: 1,
        vendorName: "Vendor Company XYZ",
        vendorState: "KARNATAKA",
        vendorCity: "KARNATAKA",
        vendorCapacity: "-",
        contactDetails: "+919912299129",
        agreementStartDate: "2023-07-21",
        agreementExpiryDate: "2024-07-21",
        PANNo: "CTWPA1190T",
        GSTINNo: "ABCDEFGHIJ1234",
        natureofService: "-",
        Product: "Motor",
      },
      {
        srNo: 2,
        vendorName: "Vendor Company XYZ",
        vendorState: "KARNATAKA",
        vendorCity: "KARNATAKA",
        vendorCapacity: "-",
        contactDetails: "+919912299129",
        agreementStartDate: "2023-07-21",
        agreementExpiryDate: "2024-07-21",
        PANNo: "CTWPA1190T",
        GSTINNo: "ABCDEFGHIJ1234",
        natureofService: "-",
        Product: "Motor",
      },
      {
        srNo: 3,
        vendorName: "Vendor Company XYZ",
        vendorState: "KARNATAKA",
        vendorCity: "KARNATAKA",
        vendorCapacity: "-",
        contactDetails: "+919912299129",
        agreementStartDate: "2023-07-21",
        agreementExpiryDate: "2024-07-21",
        PANNo: "CTWPA1190T",
        GSTINNo: "ABCDEFGHIJ1234",
        natureofService: "-",
        Product: "Motor",
      },
    ],
  },
  // 2
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "vendorCode",
        minWidth: "10rem",
        label: "Vendor Code",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "vendorCity",
        label: "Vendor City",
        align: "center",
      },

      {
        id: "mobileNumber",
        label: "Mobile Number",
        align: "left",
      },
      {
        id: "emailId",
        label: "Email Id",
        align: "left",
      },
      {
        id: "vendorCapacity",
        label: "Vendor Capacity",
        align: "left",
      },
      {
        id: "vendorCategory",
        label: "Vendor Category",
        align: "left",
      },
      {
        id: "PanVerification",
        label: "PAN Verification",
        align: "left",
      },
      {
        id: "accountVerification",
        label: "Account Verification",
        align: "left",
      },
      {
        id: "backgroundVerification",
        label: "Background Verification",
        align: "left",
      },
      {
        id: "systemConfigurationGC",
        label: "System Configuration GC",
        align: "left",
      },
      {
        id: "systemConfigurationCIMA",
        label: "System Configuration CIMA",
        align: "left",
      },
      {
        id: "approvalStatus",
        label: "Approval Status",
        align: "left",
      },
    ],
    row: [
      {
        srNo: 1,
        vendorCode: 23,
        vendorCity: "KARNATAKA",
        mobileNumber: "KARNATAKA",
        emailId: "-",
        vendorCapacity: "+919912299129",
        vendorCategory: "2023-07-21",
        PanVerification: "2024-07-21",
        accountVerification: "CTWPA1190T",
        backgroundVerification: "ABCDEFGHIJ1234",
        systemConfigurationGC: "-",
        approvalStatus: "Motor",
      },
    ],
  },
  // 3
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "claimNumber",
        minWidth: "10rem",
        label: "Claim Number",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "investigatorName",
        label: "Investigator Name",
        align: "center",
      },

      {
        id: "product",
        label: "Product",
        align: "left",
      },
      {
        id: "productCategory",
        label: "Product Category",
        align: "left",
      },
      {
        id: "tatStatus",
        label: "TAT Status",
        align: "left",
      },
      {
        id: "reportStatus",
        label: "Report Status",
        align: "left",
      },
      {
        id: "reportStandard",
        label: "Report Standard",
        align: "left",
      },
      {
        id: "blockScore",
        label: "Block Score",
        align: "left",
      },
      {
        id: "qualityScore",
        label: "Quality Score (Report + Block) (50% weight of 60%)",
        align: "left",
      },
      {
        id: "imRemark",
        label: "IM Remark",
        align: "left",
      },
      {
        id: "tatDays",
        label: "TAT Days(40)",
        align: "left",
      },
      {
        id: "finalScore",
        label: "Final Score",
        align: "left",
      },
    ],
    row: [
      {
        srNo: 1,
        claimNumber: 23,
        investigatorName: "KARNATAKA",
        product: "KARNATAKA",
        productCategory: "-",
        tatStatus: "+919912299129",
        reportStatus: "2023-07-21",
        reportStandard: "2024-07-21",
        blockScore: "CTWPA1190T",
        qualityScore: "ABCDEFGHIJ1234",
        imRemark: "-",
        tatDays: "Motor",
        finalScore: 50,
      },
    ],
  },
  // 4
  {
    column: [
      {
        id: "srNo",
        label: "Sr. No",
        align: "left",
      },
      {
        id: "nameOfAgencyOwner",
        minWidth: "10rem",
        label: "Name Of Agency Owner",
        align: "left",
        color: "red",
        cursor: "pointer",
      },
      {
        id: "vendorName",
        label: "Vendor Name",
        align: "center",
      },

      {
        id: "vendorState",
        label: "Vendor State",
        align: "left",
      },
      {
        id: "vendorCity",
        label: "Vendor City",
        align: "left",
      },
      {
        id: "registeredContactDetails",
        label: "Registered Contact Details",
        align: "left",
      },
      {
        id: "panNumber",
        label: "PAN Number",
        align: "left",
      },
      {
        id: "gstNo",
        label: "GST No",
        align: "left",
      },
      {
        id: "reasonOfBlackListing",
        label: "Reason Of BlackListing",
        align: "left",
      },
    ],
    row: [
      {
        srNo: 1,
        nameOfAgencyOwner: 23,
        vendorName: "KARNATAKA",
        vendorState: "KARNATAKA",
        vendorCity: "-",
        registeredContactDetails: "+919912299129",
        panNumber: "2023-07-21",
        gstNo: "2024-07-21",
        reasonOfBlackListing: "CTWPA1190T",
      },
    ],
  },
];

export const vendorTabLabel = [
  { id: 1, label: "Vendor Master" },
  { id: 2, label: "New Vendor Profile" },
  { id: 3, label: "Performance" },
  { id: 4, label: "Blacklisted Vendor" },
];

export const standardTabelData = [
  { id: 1, label: "Vendor Details" },
  { id: 2, label: "Statutory Details" },
  { id: 3, label: "Registration Number" },
  { id: 4, label: "Bank Details" },
  { id: 5, label: "Documents" },
];

export const gridContent = [
  //0

  {
    name: "Lorem",
    City: "Mum",
    Address: "example@example.com",
    Pin_Code: "+1234567890",
    State: "Maha",
    Capacity: "-",
    Nature_of_Firm: "+0987654321",
    LOB: "2023-07-05",
    Sub_Product: "2022-06-30",
  },
  //1
  {
    PAN: "ASCD1234E",
    TAN: "-",
    CST: "-",
  },
  //2
  {
    GST_No: "123EDG56FFE",
    HSN_No: "-",
    Sac_No: "_",
    MSME: "JAHSH65S44",
    MSME_Registration_No: "JAHSH65S44",
    Contact_Details: "9911223344",
    Registration_Address: "-",
    Contact_Person_1: "9922334455 aaa@gmail.com",
    Contact_Person_2: "9922334466 bbb@gmail.com",
  },
  //3
  {
    Account_Number: "************1234",
    Bank_Name: "ABC Bank",
    Branch_Name: "-",
    IFSC_Code: "A11110000B",
    Payment_Method: "Online",
  },
  //4
  // {
  //   documents: {
  //     name: "array",
  //     size: "178kb",
  //   },
  // },
];
export const VendorMasterActionList = [
  {
    label: "Audit Report",
    icon: AuditIcon,
    hoverIcon: AuditIconFilled,
  },
];
